export default{
  detalhes: {
    value: '',
    maxlength: '500',
    rows: 5,
    required: true,
    state: null,
    noResize: false
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/observation/new/observation-form.js